<template>
  <div id="app">
    <!-- 非微信环境提示 -->
    <div v-if="showWechatTip" class="wechat-tip-overlay">
      <div class="wechat-tip-box">
        <div class="wechat-tip-icon">
          <i class="fa-brands fa-weixin"></i>
        </div>
        <h3>请使用微信打开</h3>
        <p>本页面需要在微信中打开才能正常使用</p>
        <p class="tip-small">点击右上角 <i class="fa-solid fa-ellipsis"></i> 选择「在浏览器中打开」后复制链接，再打开微信发送给自己或文件传输助手</p>
      </div>
    </div>

    <template v-else>
      <router-view />
      <GlobalFooter :configs="siteConfigs" />
    </template>
  </div>
</template>

<script>
import GlobalFooter from './components/GlobalFooter.vue'
import { isWechat } from './utils/wechat'

export default {
  name: 'App',
  components: {
    GlobalFooter
  },
  data() {
    return {
      siteConfigs: {},
      showWechatTip: false
    }
  },
  mounted() {
    // 开发模式下跳过微信环境检测，方便调试
    const isDev = process.env.NODE_ENV === 'development'
    if (!isDev && !isWechat()) {
      this.showWechatTip = true
      return
    }
    this.fetchConfigs()
  },
  methods: {
    async fetchConfigs() {
      try {
        const base = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000'
        const res = await fetch(`${base}/api/v1/configs`)
        const data = await res.json()
        if (data.data) {
          this.siteConfigs = data.data

          // 更新页面标题
          if (data.data.site_name) {
            document.title = data.data.site_name
          }

          // 加载统计代码
          this.loadAnalysisCode(data.data)
        }
      } catch (e) {
        console.error('获取配置失败:', e)
      }
    },

    loadAnalysisCode(configs) {
      // 加载微信分析代码
      if (configs.wechat_analysis_code) {
        const script = document.createElement('script')
        script.textContent = configs.wechat_analysis_code
        document.head.appendChild(script)
      }

      // 加载百度统计代码
      if (configs.baidu_analysis_code) {
        const script = document.createElement('script')
        script.textContent = configs.baidu_analysis_code
        document.head.appendChild(script)
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  width: 100%;
  overflow-x: hidden;
  -webkit-text-size-adjust: 100%;
}

body {
  font-family: 'Noto Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f4f8fb;
  width: 100%;
  overflow-x: hidden;
}

#app {
  width: 100%;
  min-height: 100vh;
}

::-webkit-scrollbar {
  display: none;
}

/* 微信环境提示 */
.wechat-tip-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #07c160, #06ad56);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.wechat-tip-box {
  text-align: center;
  color: #fff;
  padding: 40px;
}

.wechat-tip-icon {
  font-size: 80px;
  margin-bottom: 24px;
  animation: bounce 2s ease-in-out infinite;
}

@keyframes bounce {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

.wechat-tip-box h3 {
  font-size: 24px;
  margin-bottom: 12px;
}

.wechat-tip-box p {
  font-size: 14px;
  opacity: 0.9;
  line-height: 1.6;
  margin-bottom: 8px;
}

.wechat-tip-box .tip-small {
  font-size: 12px;
  opacity: 0.7;
  margin-top: 20px;
}

.wechat-tip-box i {
  margin: 0 4px;
}

.markdown-body img {
  width: 100%;
}
</style>
